import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { getAddresses, getCareTeam } from "../services/soar";
import Checkbox from "./Checkbox";
import ClientIntakeModal from "./ClientIntakeModal";
import UpdateRecordsModal from "./UpdateRecordsModal";
import { getFieldText } from "./../../scripts/helperScripts";

function IntakeModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeModal, setActiveModal] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedModals, setSelectedModals] = useState([]);
  const [clientId, setClientId] = useState();
  const [clientProgram, setClientProgram] = useState({});
  const [fosterHomeProgram, setFosterHomeProgram] = useState();
  const [addresses, setAddresses] = useState([]);
  const [updateAddresses, setUpdateAddresses] = useState(false);
  const [careTeam, setCareTeam] = useState([]);
  const [updateCareTeam, setUpdateCareTeam] = useState(false);
  const [data, setData] = useState({});
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  const showModal = () => {
    setIsOpen(true);
  };

  const handleHideModal = () => {
    setIsOpen(false);
  };

  const handleChange = ({ currentTarget: input }) => {
    const obj = { ...data };
    obj[input.name] = input.checked;
    setData(obj);
  };

  const launchModals = () => {
    setActiveIndex(0);
    const modals = [];
    if (data.client) {
      modals.push("client");
    }
    if (data.additionalRecords) {
      modals.push("additionalRecords");
    }
    setSelectedModals(modals);
    handleHideModal();
    setActiveModal(modals[0]);
  };

  const handleNextModal = (closeAll = false) => {
    if (activeIndex + 1 < selectedModals.length && !closeAll) {
      setActiveModal(selectedModals[activeIndex + 1]);
      setActiveIndex(activeIndex + 1);
    } else {
      resetForm();
    }
  };

  const resetForm = () => {
    setClientId(null);
    setFosterHomeProgram(null);
    setActiveIndex(0);
    setActiveModal("");
    setSelectedModals([]);
    setData({});
  };

  //Adresses
  useEffect(() => {
    if (clientId || updateAddresses) {
      console.log("Getting Addresses for ", clientId);
      getAddresses(clientId).then((response) => {
        if (response && isMountedRef.current) {
          console.log("Addresses:", response);
          setAddresses(response);
        }
      });
      setUpdateAddresses(false);
    } else {
      setAddresses([]);
    }
  }, [clientId, updateAddresses]);

  //Get Care Team
  useEffect(() => {
    if (clientId || updateCareTeam) {
      console.log("Getting Care Team for ", clientId);
      getCareTeam(clientId).then((response) => {
        if (response && isMountedRef.current) {
          const contacts = response.filter(
            (collateral) =>
              getFieldText(collateral.ccx_membertype) === "803080001"
          );
          contacts.sort((a, b) => {
            if (a.ccx_name > b.ccx_name) return 1;
            else if (a.ccx_name < b.ccx_name) return -1;
            return 0;
          });
          const providers = response.filter(
            (collateral) =>
              getFieldText(collateral.ccx_membertype) === "803080002"
          );
          providers.sort((a, b) => {
            if (a.ccx_name > b.ccx_name) return 1;
            else if (a.ccx_name < b.ccx_name) return -1;
            return 0;
          });

          setCareTeam([...contacts, ...providers]);
          console.log("CareTeam: ", JSON.stringify(response));
          // addToTimeline(
          //   response,
          //   "Care Team",
          //   "ccx_careteamid",
          //   "ccx_name",
          //   "ccx_effdate",
          //   "ccx_expdate",
          //   "createdby",
          //   "createdon"
          // );
        }
      });
      setUpdateCareTeam(false);
    } else {
      setCareTeam([]);
    }
  }, [clientId, updateCareTeam]);

  const handleUpdateAddresses = () => {
    setUpdateAddresses(true);
  };

  const handleUpdateCareTeam = () => {
    setUpdateCareTeam(true);
  };

  const handleCloseUpdateRecordsModal = () => {
    setActiveModal("");
  };

  return (
    <>
      <div className="clearfix">
        <button
          className="btn bg-safy1-1 text-white float-end"
          onClick={showModal}
        >
          Intake
        </button>
      </div>
      {isOpen ? (
        <Modal show={isOpen} animation={false}>
          <Modal.Header>
            <Modal.Title>Client Intake</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Select Record Types to Create:
            <div className="m-3">
              <Checkbox
                name="client"
                label="Client, Company, Program"
                onChange={handleChange}
              />
              <Checkbox
                name="additionalRecords"
                label="Additional Records"
                onChange={handleChange}
                disabled={!data.client}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger" onClick={handleHideModal}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={launchModals}>
              Start
            </button>
          </Modal.Footer>
        </Modal>
      ) : null}
      {activeModal === "client" ? (
        <ClientIntakeModal
          isOpen={activeModal === "client"}
          nextModal={
            data.additionalRecords === true ? handleNextModal : resetForm
          }
          isLastModal={activeIndex === selectedModals.length - 1}
          setClientId={setClientId}
          setClientProgram={setClientProgram}
          setFosterHomeProgram={setFosterHomeProgram}
          closeUpdateRecordsModal={handleCloseUpdateRecordsModal}
        ></ClientIntakeModal>
      ) : null}
      {activeModal === "additionalRecords" ? (
        <UpdateRecordsModal
          forceOpen={activeModal === "additionalRecords"}
          forceClose={handleNextModal}
          clientId={clientId}
          clientProgram={clientProgram}
          fosterHomePrograms={fosterHomeProgram ? [fosterHomeProgram] : []}
          addresses={addresses}
          updateAddresses={handleUpdateAddresses}
          existingCareTeam={careTeam}
          updateCareTeam={handleUpdateCareTeam}
        ></UpdateRecordsModal>
      ) : null}
    </>
  );
}

export default IntakeModal;
